<template>
  <layout>
    <section>
      <div class="columns">
        <div class="column">
          <h1>Settings</h1>
          <hr />
          <form @submit.prevent="detailsSubmit">
            <b-message
              v-if="detailsForm.wasSuccessful"
              type="is-success"
              has-icon
            >
              Details Updated Successfully
            </b-message>
            <b-field label="First Name">
              <b-input v-model="detailsForm.first_name"> </b-input>
              <div v-if="validationError('first_name')" class="help is-danger">
                {{ validationError('first_name') }}
              </div>
            </b-field>
            <b-field label="Last Name">
              <b-input v-model="detailsForm.last_name"> </b-input>
              <div v-if="validationError('last_name')" class="help is-danger">
                {{ validationError('last_name') }}
              </div>
            </b-field>
            <b-field label="Email">
              <b-input type="email" v-model="detailsForm.email"> </b-input>
              <div v-if="validationError('email')" class="help is-danger">
                {{ validationError('email') }}
              </div>
            </b-field>
            <button
              type="submit"
              class="button is-primary"
              :disabled="detailsForm.processing"
            >
              Save
            </button>
          </form>
          <hr />
          <form @submit="passwordSubmit">
            <b-field label="Reset Password">
              <b-input
                type="password"
                v-model="passwordForm.password"
                @keyup.native="passwordChecker"
                password-reveal
              >
              </b-input>
            </b-field>
            <div v-if="validationError('password')" class="help is-danger">
              {{ validationError('password') }}
            </div>
            <div class="passwordStrengthBar" v-if="passwordForm.password">
              <label for="#">Password Strength</label>
              <b-progress
                v-if="passwordScore < 51"
                :value="passwordScore"
                show-value
                type="is-danger"
              >
              </b-progress>
              <b-progress
                v-if="passwordScore > 50"
                :value="passwordScore"
                show-value
                type="is-success"
              >
              </b-progress>
            </div>
            <b-field label="Confirm Password" v-if="passwordForm.password">
              <b-input
                type="password"
                v-model="passwordForm.password_confirmation"
                password-reveal
              >
              </b-input>
            </b-field>
            <button
              type="submit"
              class="button is-primary"
              :disabled="passwordForm.processing"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';

var passwordMeter = require('passwordmeter');

export default {
  components: {
    Layout,
  },
  props: {
    errors: {
      type: Object,
    },
    success_message: {
      type: String,
    },
  },
  data() {
    return {
      passwordScore: -1,
      // top form (details form)
      detailsForm: {
        first_name: this.$page.props.auth.user.first_name,
        last_name: this.$page.props.auth.user.last_name,
        email: this.$page.props.auth.user.email,
      },

      passwordForm: {
        password: '',
        password_confirmation: null,
        isSending: false,
      },
    };
  },
  methods: {
    passwordChecker: function () {
      this.passwordScore = passwordMeter.checkPass(
        this.passwordForm.password,
        8
      );
    },
    detailsSubmit: function () {
      this.$inertia.put('/feedback/account/', this.detailsForm);
    },
    passwordSubmit: function () {
      this.$inertia.post(
        this.route('feedback.account.passwordUpdate'),
        this.passwordForm,
        {
          onStart: () => (this.passwordForm.isSending = true),
          onFinish: () => (this.passwordForm.isSending = false),
        }
      );
    },
  },
};
</script>
